import React from "react";
import "./App.css";
import Board from "./components/board.js";

export default function App () {
  return (
    <div id="app-root">
      <h1>Fourtitude</h1>
      <Board />
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/App.js